import type { BrandProfilesListQuery } from "src/graphql/types";
import { getStoredValue, setStoredValue } from "src/hooks/use-persisted-state";

type Profile = Pick<
  BrandProfilesListQuery["brand_profiles"][number],
  "id" | "is_default"
>;

const storageKey = (workspaceId: string) =>
  `${workspaceId}:ad-studio:brand-profile-id`;

export function getPreferredAdStudioBrandProfileId(
  profiles: readonly Profile[] | undefined,
  workspaceId: string | undefined,
): string | undefined {
  const storedId = workspaceId
    ? getStoredValue<unknown>(storageKey(workspaceId), undefined)
    : undefined;

  return (
    profiles?.find((profile) => profile.id === storedId)?.id ??
    profiles?.find((profile) => profile.is_default)?.id ??
    profiles?.[0]?.id
  );
}

export function saveAdStudioBrandProfileId(
  workspaceId: string | undefined,
  profileId: string,
): void {
  if (workspaceId) {
    setStoredValue(storageKey(workspaceId), profileId);
  }
}
